/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Print_HeaderInputs */

const vi_tea_purchase_print_header = /** @type {(inputs: Tea_Purchase_Print_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐƠN MUA CHÈ TỪ HỘ`)
};

/**

* @param {Tea_Purchase_Print_HeaderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_print_header = /** @type {((inputs?: Tea_Purchase_Print_HeaderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Print_HeaderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_print_header(inputs)
});